module.exports = __webpack_public_path__ + "prod/1.42.2/img/pain-1.273f7ba9.svg";